import { Component, ElementRef, EventEmitter, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import moment from 'moment';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ask-for-date',
  templateUrl: './ask-for-date.component.html',
  styleUrls: [
    './ask-for-date.component.scss',
    '../../../../../fragments/modal/modal.fragment.scss'
  ]
})
export class AskForDateComponent implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public closeEmitter = new EventEmitter();
  public formGroup: FormGroup;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder
  ) {
    this.formGroup = this._formBuilder.group({
      date: []
    });
  }

  ngOnInit(): void {
  }

  public validDate(): void {
    this.closeModal(moment(this.formGroup.get('date').value).toDate());
  }

  public closeModal(date?: Date): void {
    this.closeEmitter.emit(date && date.getTime() === date.getTime() ? date : undefined);
  }

}
